/**
 * AuthContext - Backward compatible re-export.
 *
 * This file maintains backward compatibility with existing imports.
 * The actual implementation has been split into modular components
 * under contexts/auth/.
 *
 * New code should import directly from 'contexts/auth':
 * @example
 * import { AuthProvider, useAuth } from '../contexts/auth';
 *
 * Or use the new hooks for more granular access:
 * @example
 * import { useAuthState, useAuthActions } from '../contexts/auth';
 */

// Re-export everything from the new modular auth system
export { AuthProvider, useAuth, AuthContext } from './auth';

// Default export for backward compatibility
import { AuthContext } from './auth';
export default AuthContext;
